import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Stethoscope } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { websiteSetupDestination } from "@/lib/websiteSetup";

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    api.post("/auth/google-session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState({}, "", location.pathname);
        navigate(websiteSetupDestination(data), { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/login?error=google", { replace: true }));
  }, [location.hash, location.pathname, navigate, setUser]);
  return <main className="auth-callback" data-testid="auth-callback-screen"><Stethoscope size={34}/><h1>Completing your diagnosis…</h1></main>;
}
